import { RootRoutes, RoutesRoutes } from '../codegen';

function mountRoute(route: string, prefix: string = RootRoutes.ROUTE_APPLICATION): string {
  return `${prefix}${route}`;
}

export const Routes = {
  MEUS_DADOS: mountRoute(RoutesRoutes.ROUTE_MEUS_DADOS),
  DASHBOARD: mountRoute(RoutesRoutes.ROUTE_DASHBOARD),
  DETALHES_REQUISICAO: mountRoute(RoutesRoutes.ROUTE_DETALHES_REQUISICAO),
  HISTORICO_AUTORIZACOES: mountRoute(RoutesRoutes.ROUTE_HISTORICO_AUTORIZACOES),
  MENSALIDADES: mountRoute(RoutesRoutes.ROUTE_MENSALIDADES),
  SOLICITAR_CANCELAMENTO: mountRoute(RoutesRoutes.ROUTE_SOLICITAR_CANCELAMENTO),
  CONSENTIMENTOS: mountRoute(RoutesRoutes.ROUTE_CONSENTIMENTOS),
  RECEBER_BOLETOS_EMAIL: mountRoute(RoutesRoutes.ROUTE_RECEBER_BOLETOS_EMAIL),
  DADOS_PESSOAIS: mountRoute(RoutesRoutes.ROUTE_DADOS_PESSOAIS),
  DADOS_CONTRATO: mountRoute(RoutesRoutes.ROUTE_DADOS_CONTRATO),
  DETALHES_REQUISICAO_AUTORIZACAO: mountRoute(RoutesRoutes.ROUTE_DETALHES_REQUISICAO_AUTORIZACAO),
  DETALHES_AUTORIZACAO: mountRoute(RoutesRoutes.ROUTE_DETALHES_AUTORIZACAO),
  SOLICITAR_PARTICIPACAO: mountRoute(RoutesRoutes.ROUTE_SOLICITAR_PARTICIPACAO),
  DINAMICO: mountRoute(RoutesRoutes.ROUTE_DINAMICO),
  HISTORICO_CANCELAMENTOS: mountRoute(RoutesRoutes.ROUTE_HISTORICO_CANCELAMENTOS),
  HISTORICO_REQUISICOES: mountRoute(RoutesRoutes.ROUTE_HISTORICO_REQUISICOES),
  HISTORICO_PARTICIPACOES: mountRoute(RoutesRoutes.ROUTE_HISTORICO_PARTICIPACOES),
  HISTORICO_PROTOCOLOS: mountRoute(RoutesRoutes.ROUTE_HISTORICO_PROTOCOLOS),
  INFORMACOES_ADICIONAIS: mountRoute(RoutesRoutes.ROUTE_INFORMACOES_ADICIONAIS),
  SOLICITAR_VIA: mountRoute(RoutesRoutes.ROUTE_SOLICITAR_VIA),
  MENSAGENS: mountRoute(RoutesRoutes.ROUTE_MENSAGENS),
  DETALHES_MENSAGEM: mountRoute(RoutesRoutes.ROUTE_DETALHES_MENSAGEM),
  CHAMADOS: mountRoute(RoutesRoutes.ROUTE_CHAMADOS),
  TIPO_CHAMADO: mountRoute(RoutesRoutes.ROUTE_TIPO_CHAMADO),
  NOVO_CHAMADO: mountRoute(RoutesRoutes.ROUTE_NOVO_CHAMADO),
  DETALHES_CHAMADO: mountRoute(RoutesRoutes.ROUTE_DEATLHES_CHAMADO),
  PRIVACY: mountRoute(RoutesRoutes.ROUTE_PRIVACY),
  ASSIGN_ADITIVO_CONTRATUAL : '/aditivo-contratual/:nrSeqBeneficiario/termo/:nrSeqTermo',
};
